import React, { useState, useEffect } from 'react';
import SelectWithTokensSelectListItem from '../../shared/SelectWithTokensSelectListItem';
import { preferenceCerealMixSelectService } from '../../services/preferenceCerealMixSelectService';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';

const CreateCerealMixBlock = ({ closeCallback, selectManager }) => {
    const [possibleListLength, setPossibleListLength] = useState();
    const { i18n } = useTranslation();
    const addNewCerealMix = () => {
        preferenceCerealMixSelectService.addNewCerealMix(selectManager);
        closeCallback(prev => !prev);
    };
    
    const changePossibleList = () => {
        setPossibleListLength(selectManager.getPossibleItems().length);
    };

    useEffect(() => {
        selectManager.registerItemsChangingObserver(changePossibleList);
        changePossibleList();
        return () => {
            selectManager.unRegisterItemsChangingObserver(changePossibleList);
        };
    }, []);

    return (
        <ul>
            <div className="scroll product__forms-container">  
                {possibleListLength > 0 ?
                    selectManager.getPossibleItems().map((it) => (
                        <React.Fragment key={it.itemId}>
                            <SelectWithTokensSelectListItem selectWithTokensManager={selectManager}
                                selectItem={{...it, included: true}} />
                        </React.Fragment>
                    ))
                    :
                    null}
            </div>
            <div className="preference__mix flex items-center justify-between gap-12 px-20 py-12">
                <Button variant="ghost" size="small" onClick={() => closeCallback(false)}>
                    {i18n.t('app.page.product.close')}
                </Button>
                <Button size="small" onClick={addNewCerealMix}>
                    {i18n.t('app.page.product.add')}
                </Button>
            </div>
        </ul>
    );
};

export default CreateCerealMixBlock;
